import React, { useState, useEffect } from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function VariationsOptions(props) {
    // props
    const { variantMainFields, handleVariantPageShow } = props

    // states
    const [activeTab, setActiveTab] = useState()

    // setting active tab
    useEffect(() => {
        if (variantMainFields?.length) {
            setActiveTab(variantMainFields[0].variation_name)
        }
    }, [variantMainFields])


    // handle tab change
    const handleTabChange = (ev, tab) => {
        ev.preventDefault()

        // setting active tab
        setActiveTab(tab)
    }

    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner variation-options-view">
                    <div className="btns mb-3">
                        <button className="st-btn st-btn-white-gray-outlined st-btn-sm d-flex align-items-center text-capitalize" onClick={handleVariantPageShow}>
                            <span className="round-feather-icon-outlined d-inline-flex align-items-center justify-content-center me-2">
                                <FeatherIcon
                                    icon="plus"
                                    size="10"
                                    className="icon cursor-pointer" />
                            </span>
                            <span>
                                {
                                    variantMainFields?.length ? "add or edit option" : "new option"
                                }
                            </span>
                        </button>
                    </div>

                    {/* frac */}
                    <div className="frac d-flex">
                        {/* top sec */}
                        <div className="vov-links-container">
                            {
                                variantMainFields?.length ? variantMainFields.map((item, index) => (
                                    <a key={item.variation_id}
                                        href="/"
                                        className={`vov-link d-block ${activeTab === item.variation_name ? "active" : ""}`}
                                        onClick={ev => handleTabChange(ev, item.variation_name)}
                                    >
                                        {item.variation_name}
                                    </a>
                                )) : null
                            }
                        </div>

                        {/* content sec */}
                        <div className="content-sec media-body">
                            {
                                variantMainFields?.length ? variantMainFields.map((item, index) => {
                                    return (
                                        <div key={item.variation_id} className={`content-item ${activeTab === item.variation_name ? "active" : ""}`}>
                                            <div className="inner d-flex flex-wrap">
                                                <div className="frac">
                                                    <p className="head st-fs-12 st-fw-600 st-text-color2 mb-1">Option Name</p>
                                                    <p className="desc">{item.variation_name}</p>
                                                </div>
                                                <div className="frac">
                                                    <p className="head st-fs-12 st-fw-600 st-text-color2 mb-1">Option Type</p>
                                                    {
                                                        item.display_type === "radio_buttons" && (
                                                            <p className="desc">Radio Buttons</p>
                                                        )
                                                    }
                                                    {
                                                        item.display_type === "rectangle_list" && (
                                                            <p className="desc">Rectangle List</p>
                                                        )
                                                    }
                                                    {
                                                        item.display_type === "dropdown" && (
                                                            <p className="desc">Dropdown</p>
                                                        )
                                                    }
                                                </div>
                                                <div className="frac">
                                                    <p className="head st-fs-12 st-fw-600 st-text-color2 mb-1">Option Values</p>

                                                    {
                                                        item.options?.length && item.options.map(item => (
                                                            <p key={item.id} className="desc">{item.value}</p>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }) : null
                            }
                        </div>
                    </div>

                    {/* frac */}
                    <div className="frac">
                        {/* heading */}
                        <p className="box-heading st-fs-15 st-fw-600 st-text-color mb-2">Try Product Variations</p>
                        <p className="st-fs-13 st-text-color2 mb-3">
                            Looking to add stock control, images, SKUs and prices to product options? Product variations let you specify these details for each combination of products options manually.
                        </p>
                        <button className="st-btn st-btn-primary st-btn-sm text-capitalize st-fw-400 st-fs-13">
                            Manage Product Variations
                        </button>
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}
